import { render, staticRenderFns } from "./BadgeRow.vue?vue&type=template&id=dcde037a&scoped=true&"
import script from "./BadgeRow.vue?vue&type=script&lang=js&"
export * from "./BadgeRow.vue?vue&type=script&lang=js&"
import style0 from "./BadgeRow.vue?vue&type=style&index=0&id=dcde037a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcde037a",
  null
  
)

export default component.exports